
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function WeaponMasteryPropertyIndex() {
  return (
    <FSIndex
      data_type="weapon_mastery_property"
    />
  );
}
